import { useAccountSideMenuStyle } from './account-side-menu.styles'

export const useAccountSideMenu = () => {
  const classes = useAccountSideMenuStyle()

  return {
    classes,
  }
}
